// src/firebase/client.js
import { initializeApp } from "firebase/app"
import { getFirestore } from "firebase/firestore"
import { connectFunctionsEmulator, getFunctions } from "firebase/functions"

const firebaseConfig = {
  apiKey: "AIzaSyBIfHn9JT4oDljDDqhkcH5K65eVgkt6OEo",
  authDomain: "analytics-376d0.firebaseapp.com",
  projectId: "analytics-376d0",
  storageBucket: "analytics-376d0.firebasestorage.app",
  messagingSenderId: "488980650415",
  appId: "1:488980650415:web:4765142be075436244b75a"
};

export const app = initializeApp(firebaseConfig)

export const db = getFirestore(app)

const functionsRegion =
  process.env.GATSBY_FIREBASE_FUNCTIONS_REGION || "europe-west1"

export const functionsClient = getFunctions(app, functionsRegion)

if (
  typeof window !== "undefined" &&
  process.env.GATSBY_FIREBASE_FUNCTIONS_EMULATOR_HOST
) {
  const [host, port] = process.env.GATSBY_FIREBASE_FUNCTIONS_EMULATOR_HOST.split(":")
  connectFunctionsEmulator(functionsClient, host, Number(port || 5001))
}
